// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.67 7.31V4.86C10.67 3.31 9.47 2.05 8 2.05C7.26 2.05 6.58 2.37 6.1 2.89M3 6.5V7.46C3 10.22 5.24 12.46 8 12.46M13 6.5V7.46C13 8.12 12.87 8.75 12.64 9.32M8 12.46V14M8 12.46C8.34 12.46 8.67 12.43 8.99 12.36M2 2L14 14M7.1 9.95C6.55 9.75 6.09 9.37 5.78 8.87',
];
